import { render, staticRenderFns } from "./RsaConfigurazioneSettingsListComponent.vue?vue&type=template&id=714bbdb2"
import script from "./RsaConfigurazioneSettingsListComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneSettingsListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports